export const fundsOriginOption = [
  { value: 'salary', text: 'Remuneraciones' },
  { value: 'savings', text: 'Ahorros' },
  { value: 'dividends', text: 'Dividendos' },
  { value: 'rent', text: 'Alquileres' },
  { value: 'stock_sale', text: 'Venta de acciones' },
  { value: 'property_sale', text: 'Venta de inmuebles' },
  { value: 'inheritance', text: 'Herencias' },
  { value: 'loans', text: 'Préstamos' },
  { value: 'donation', text: 'Donación' },
  { value: 'lottery', text: 'Sorteos' },
  { value: 'third_party_funds', text: 'Fondo de terceros' },
  { value: 'other', text: 'Otros' },
];

export const fundsOriginLocation = [
  { value: 'amazonas', text: 'Amazonas' },
  { value: 'ancash', text: 'Ancash' },
  { value: 'apurimac', text: 'Apurímac' },
  { value: 'arequipa', text: 'Arequipa' },
  { value: 'ayacucho', text: 'Ayacucho' },
  { value: 'cajamarca', text: 'Cajamarca' },
  { value: 'callao', text: 'Callao' },
  { value: 'cusco', text: 'Cusco' },
  { value: 'huancavelica', text: 'Huancavelica' },
  { value: 'huanuco', text: 'Huánuco' },
  { value: 'ica', text: 'Ica' },
  { value: 'junin', text: 'Junín' },
  { value: 'la_libertad', text: 'La Libertad' },
  { value: 'lambayeque', text: 'Lambayeque' },
  { value: 'lima', text: 'Lima' },
  { value: 'loreto', text: 'Loreto' },
  { value: 'madre_de_dios', text: 'Madre de Dios' },
  { value: 'moquegua', text: 'Moquegua' },
  { value: 'pasco', text: 'Pasco' },
  { value: 'piura', text: 'Piura' },
  { value: 'puno', text: 'Puno' },
  { value: 'san_martin', text: 'San Martín' },
  { value: 'tacna', text: 'Tacna' },
  { value: 'tumbes', text: 'Tumbes' },
  { value: 'ucayali', text: 'Ucayali' },
  { value: 'cuba', text: 'Cuba' },
  { value: 'iran', text: 'Irán' },
  { value: 'myanmar', text: 'Myanmar' },
  { value: 'yemen', text: 'Yemen' },
  { value: 'north_korea', text: 'Corea del Norte' },
  { value: 'sudan', text: 'Sudán' },
  { value: 'syria', text: 'Siria' },
  { value: 'other', text: 'Otros' },
];
